import './styles/InvoiceManagement.scss';

import { Badge, CircularProgress, Grid, Paper, Tab, Tabs } from '@mui/material';
import { InvoicesList } from '@thro-types/jobmarket';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import {
  useJobmarketBillableJobPeriodsCountQuery,
  useJobmarketInvoicesQuery
} from 'api/hooks/jobmarket/invoices';
import { translations } from 'locales/i18n';
import usePageHeading from 'utils/hooks/usePageHeading';

import { Invoices } from './components/Invoices';
import { OpenOffers } from './components/OpenOffers';

interface Props {
  company?: boolean;
}

export function InvoiceManagement(props: Props) {
  const { id: companyId } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  const { data: invoicesData, isLoading } = useJobmarketInvoicesQuery({
    params: { companyId: props.company ? companyId : undefined }
  });

  // const invoicesQuery = useQuery<any, any>(
  //   QUERY,
  //   props.company
  //     ? {
  //         variables: { companyId: parseInt(companyId!, 10) },
  //         context: { clientName: 'federation' }
  //       }
  //     : { context: { clientName: 'federation' } }
  // );

  const { data: count, isLoading: isLoadingCount } = useJobmarketBillableJobPeriodsCountQuery();

  usePageHeading({
    heading: t(translations.layout.menu.manageInvoices()),
    desktopOnly: true
  });

  const renderTabs = (data: InvoicesList, invoiceCount: number) => {
    if (props.company) {
      return (
        <Tabs
          indicatorColor="primary"
          value={activeTab}
          onChange={(e, newVal) => setActiveTab(newVal)}
          className="invoice-management__tabs"
        >
          <Tab
            label={
              <Badge color="primary" badgeContent={data?.openInvoicesCount}>
                {t(translations.pages.invoices.tabs.existingInvoices())}
              </Badge>
            }
          />
        </Tabs>
      );
    }
    return (
      <Tabs
        indicatorColor="primary"
        value={activeTab}
        onChange={(e, newVal) => setActiveTab(newVal)}
        className="invoice-management__tabs"
      >
        <Tab
          label={
            <Badge color="primary" badgeContent={invoiceCount}>
              {t(translations.pages.invoices.tabs.openOffers())}
            </Badge>
          }
        />
        <Tab
          label={
            <Badge color="primary" badgeContent={data?.openInvoicesCount}>
              {t(translations.pages.invoices.tabs.existingInvoices())}
            </Badge>
          }
        />
      </Tabs>
    );
  };

  const renderTabContent = () => {
    if (props.company) {
      switch (activeTab) {
        case 0:
          return <Invoices company={companyId} paid={false} />;
        case 1:
          return <Invoices paid company={companyId} />;
        default:
          return null;
      }
    }
    switch (activeTab) {
      case 0:
        return <OpenOffers />;
      case 1:
        return <Invoices paid={false} />;
      default:
        return null;
    }
  };

  if (isLoading || isLoadingCount) {
    return <CircularProgress />;
  }
  const invoiceCount = count as number;

  return (
    <Grid container component={Paper} square elevation={1} className="invoice-management">
      {renderTabs(invoicesData!, invoiceCount)}
      {renderTabContent()}
    </Grid>
  );
}
